import { useQuery, useMutation } from '@tanstack/react-query-v4';
import API from 'react-scale/corp/components/OTS/api';
import { DataStreamNoSamplesDTO } from '@scale/customer-app-shared';
import { UpdateOTSTasksStatusReqBody } from '@scale/shared/ots';

export function useGetDataStreams(enabled = true) {
  return useQuery<DataStreamNoSamplesDTO[]>({
    queryKey: ['dataStreams'],
    queryFn: async () => {
      const res = await API.taskBank.getDataStreams();
      return res;
    },
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}

export function useGetTaskBankTasks() {
  return useMutation({
    mutationFn: async (taskIds: string[]) => {
      const res = await API.taskBank.fetchTasks(taskIds);
      return res;
    },
  });
}

export function useUpdateTasksStatusMutation() {
  return useMutation({
    mutationFn: async (reqBody: UpdateOTSTasksStatusReqBody) => {
      const res = await API.taskBank.updateTasksStatus(reqBody);
      return res;
    },
  });
}
